<template>
  <SupportPageCard
    page-class="faq-list"
    :title="languages.FAQ || 'FAQ'"
    :show-back="!hideBackBtn"
    @back="back"
  >
    <template #toolbar>
      <div class="faq-list-wrap">
        <faq-notice-bar :source="locationType.faqListPage"></faq-notice-bar>
      </div>
    </template>

    <div class="faq-list-content">
      <van-tabs
        v-model="firstClassActive"
        class="faq-list-type-1"
        :swipe-threshold="4"
        :ellipsis="false"
        @click="handleFirstClassClick"
        ref="firstClassRef"
      >
        <van-tab v-for="item in faqClassList" :key="item.id" :name="item.id">
          <template #title>
            <div class="faq-list-title">
              <div class="faq-list-title-ico-wrap">
                <img
                  :src="item.icon"
                  class="faq-list-title-ico iconfont icon-bo"
                  v-if="item.icon"
                />
                <em class="icon iconfont icon-box" v-else></em>
              </div>
              <p class="faq-list-title-text">
                {{ item.text }}
              </p>
            </div>
          </template>
          <van-tabs
            class="faq-list-type-2"
            v-model="secondTypeActive[item.id]"
            @click="handleSecondClassClick"
            :ellipsis="false"
            v-if="showTabs && item.id == firstClassActive"
          >
            <van-tab
              v-for="sub in item.sub"
              :key="sub.id"
              :title="sub.text"
              :name="sub.id"
            >
              <van-list
                v-if="
                  secondClassList[sub.id] && secondClassList[sub.id].length > 0
                "
              >
                <van-cell
                  class="faq-list-type-2-item"
                  v-for="article in secondClassList[sub.id]"
                  :key="article.id"
                  :title="article.TITLE"
                  @click="goToDetail(article.ID)"
                />
              </van-list>
              <p v-else class="faq-list-tips">
                {{ loading ? 'Loading' : languages.smartOrderComing }}
              </p>
            </van-tab>
          </van-tabs>
        </van-tab>
      </van-tabs>
    </div>
  </SupportPageCard>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import SupportPageCard from '@components/officialSupport/common/SupportPageCard.vue';
import FaqNoticeBar from '@components/officialSupport/FaqNoticeBar.vue';
import {
  locationType,
  clickButton
} from '@plugins/biPoint/_configOfficialSupport';
import pointStayTime from '@mixins/officialSupport/pointStayTime';
import globalConfig from '@utiles/globalConfig';

const hideBackBtn = globalConfig.getHrefParam('hideBackBtn') == 1;

export default {
  name: 'WorkFaqList',
  mixins: [pointStayTime],
  data() {
    return {
      firstClassActive: 0,
      secondTypeActive: {},
      secondClassList: {},
      nowListLang: '',
      loading: false,
      locationType,
      showTabs: false,
      hideBackBtn
    };
  },
  computed: {
    ...mapState({
      curLang: state => state.curLang,
      languages: state => state.languages,
      letter: state => state.languages?.mywork,
      isLogin: state => state.isLogin,
      faqSiteName: state => state.faqSiteName,
      faqClassList: state => state.faqClassList
    }),
    firstClassId() {
      return this.$route.query.firstClassId;
    }
  },
  async created() {
    this.initSecondClassActive();
    this.nowListLang = this.curLang;
  },
  deactivated() {
    this.showTabs = false;
  },
  activated() {
    this.showTabs = true;
    this.$refs?.firstClassRef?.tabs?.resize();
  },
  methods: {
    ...mapActions(['getFaqClassArticleList']),
    back() {
      if (globalConfig.isTiktokMiniProgram()) {
        this.$router.push('/workhome');
      } else {
        this.$router.go(-1);
      }
    },
    goToDetail(faqId) {
      clickButton({
        btnName: 'goFaqDetail',
        locationKey: locationType.faqListPage,
        otherParams: {
          faqId
        }
      });
      this.$router.push({
        name: 'workfaqdetail',
        query: {
          faqId
        }
      });
    },
    initSecondClassActive() {
      this.faqClassList.forEach(item => {
        this.$set(this.secondTypeActive, item.id, 0);
      });
    },
    async loadSecondClassList(id) {
      try {
        if (this.secondClassList[id]) return;
        this.loading = true;
        const data = await this.getFaqClassArticleList({
          classId: id
        });

        this.$set(this.secondClassList, id, data);
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleFirstClassClick(name) {
      clickButton({
        btnName: 'clickFaqFirstClass',
        locationKey: locationType.faqListPage,
        otherParams: {
          faqClassId: name
        }
      });
    },
    handleSecondClassClick(name) {
      clickButton({
        btnName: 'clickFaqSecondClass',
        locationKey: locationType.faqListPage,
        otherParams: {
          faqClassId: name
        }
      });
    }
  },
  watch: {
    firstClassId: {
      handler(val) {
        this.firstClassActive = val;
      },
      immediate: true
    },
    secondTypeActive: {
      handler(val) {
        Object.keys(val).forEach(key => {
          if (val[key] == 0 || this.secondClassList[val[key]]) return;
          this.loadSecondClassList(val[key]);
        });
      },
      immediate: true,
      deep: true
    },
    curLang(val) {
      if (this.nowListLang != val) {
        this.initSecondClassActive();
        this.secondClassList = {};
        this.nowListLang = val;
        Object.keys(this.secondTypeActive).forEach(key => {
          if (
            this.secondTypeActive[key] == 0 ||
            this.secondClassList[this.secondTypeActive[key]]
          )
            return;
          this.loadSecondClassList(this.secondTypeActive[key]);
        });
      }
    }
  },
  components: {
    SupportPageCard,
    FaqNoticeBar
  }
};
</script>
